<template>
  <div class="contact-info">
    <p>
      Fresh IT Solutions<br />
      Straat van Malakka 6<br />
      2622 KM Delft
    </p>

    <p>
      <a href="mailto:info@freshitsolutions.nl">info@freshitsolutions.nl</a><br />
      <a href="tel:0613454693">06 14 76 77 27</a><br />
      NL82 KNAB 0258 5449 45
    </p>

    <p>
      KVK 55357881<br />
      BTW Nr. NL001711413B83
    </p>
  </div>
</template>

<script>
export default {
  name: 'ContactInfo',
};
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions', '~bootstrap/scss/variables', '~bootstrap/scss/mixins';
@import '../styles/variables';
@import '../styles/mixins';

.contact-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  @include media-breakpoint-up(md) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    text-align: left;
  }

  p {
    @include media-breakpoint-up(md) {
      margin-right: pxToRem(70px);
    }

    @media (min-width: 1283px) {
      margin-right: pxToRem(30px);
    }
  }

  a {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;

    &:hover {
      color: $white;
      text-decoration: underline;
    }
  }
}
</style>
